import { CrudModel } from "./_crud";

export class DiseaseModel extends CrudModel {
	constructor() {
		super("admin/disease");
	}
}

export default new DiseaseModel();
